module.exports = __webpack_public_path__ + "img/rot04.b606ebf6.jpg";